export const SET_AD = '[mutations] set ad';
export const GET_AD = '[getters] get ad';